import { Add } from '@mui/icons-material';
import {
  Button,
  CardHeader,
  Grid,
  Modal,
  SvgIcon,
  tableCellClasses,
  useMediaQuery,
} from '@mui/material';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import moment from 'moment';
import { useEffect, useState, type FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BootstrapDialog } from 'src/components/common-modals/BootstrapDialog';
import SucessModal from 'src/components/sucess-modal';
import DeleteIconPTO from 'src/icons/untitled-ui/duocolor/delete-icon-pto';
import { useCreatePtoGate } from './use-create-pto-gate';
import {
  getAllPtoRequestAction,
  removePtoRequest,
  resetRemovePtoRequest,
} from 'src/redux/actions/myAvailabilityAction';
import ConfirmDeleteModal from './confirm-delete-modal';
import RequestPTO from './request-pto';
import useCurrentUser from 'src/hooks/use-current-user';

interface MyRequestProps {}

interface PtoList {
  allDay: boolean;
  description: string;
  endDate: string;
  hours: string;
  ptoStatus: string;
  startDate: string;
  uuid: string;
}


export const MyRequest: FC<MyRequestProps> = (props) => {
  const { ...other } = props;

  const [openPtoModal, setOpenPtoModal] = useState(false);
  const [sucessFullRequest, setSucessFullRequest] = useState(false);
  const [userProviderId] = useCurrentUser(['providerId']);
  const getAllPtoRequestResponse = useSelector((state: any) => state.getAllPtoRequestReducer);
  const getCretedAptResponse = useSelector((state: any) => state.createPtoRequestReducer);
  const removePtoReducer = useSelector((state: any) => state.removePtoRequestReducer);
  const dispatch = useDispatch();
  // Segment B: Create-PTO gate migrated to the instrumented scopeKey path.
  const canCreatePto = useCreatePtoGate();
  const [getAllPtoError, setGetAllPtoError] = useState('');
  const [ptoList, setPtoList] = useState([]);

  const handleRequestPTO = () => {
    setOpenPtoModal(true);
  };

  const closePTOModal = () => {
    setOpenPtoModal(false);
  };

  const [successModalTitle, setSuccessModalTitle] = useState({
    title: '',
    message: '',
  });
  const openSucessModal = () => {
    closePTOModal();
    setSuccessModalTitle((prev) => ({
      ...prev,
      title: 'PTO Request Sent',
      message: 'Your request is currently pending and can be found in the My request box',
    }));
    setSucessFullRequest(true);
  };

  const closeSuccessModal = () => {
    setSucessFullRequest(false);
  };
  const [rowId, setRowId] = useState('');

  useEffect(() => {
    setGetAllPtoError('');
    const providerId = userProviderId || undefined;
    if (providerId === undefined) return;
    dispatch(getAllPtoRequestAction(typeof providerId === 'string' ? providerId : ''));
  }, [userProviderId, getCretedAptResponse, removePtoReducer]);

  useEffect(() => {
    setGetAllPtoError('');
    if (!getAllPtoRequestResponse.getAllPtoRequest && getAllPtoRequestResponse.response === null) {
      return;
    }

    if (!getAllPtoRequestResponse.getAllPtoRequest && getAllPtoRequestResponse.response !== null) {
      setGetAllPtoError(getAllPtoRequestResponse.response?.message);
      return;
    }

    if (getAllPtoRequestResponse.response?.data?.length === 0) {
      setGetAllPtoError("No PTO's Found");
    } else {
      setPtoList(getAllPtoRequestResponse.response?.data);
    }
  }, [getAllPtoRequestResponse]);

  const [deletePtoId, setDeletePtoId] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [errorWhileDelete, setErrorWhileDelete] = useState(false);
  const isLessThan1140 = useMediaQuery('(max-width: 1439px)');

  useEffect(() => {
    if (!removePtoReducer.isRemoved && removePtoReducer?.response === null) return;
    if (!removePtoReducer.isRemoved && removePtoReducer?.response !== null) {
      setOpenDeleteModal(false);
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Error 404',
        message: 'Cannot delete the request.',
      }));
      setErrorWhileDelete(true);
      setSucessFullRequest(true);
      setDeletePtoId('');
      dispatch(resetRemovePtoRequest());
      return;
    }

    setErrorWhileDelete(false);
    setOpenDeleteModal(false);
    setSuccessModalTitle((prev) => ({
      ...prev,
      title: 'PTO Request Deleted Successfully!',
      message: '',
    }));
    setSucessFullRequest(true);
    setDeletePtoId('');
    dispatch(resetRemovePtoRequest());
  }, [removePtoReducer]);

  const handleDeletePtoRequest = (ptoId: string) => {
    setDeletePtoId(ptoId);
    setOpenDeleteModal(true);
  };

  const handleCloseInfo = () => {
    setOpenDeleteModal(false);
  };

  const confirmHandleDeleteModal = (ptoId: string) => {
    dispatch(removePtoRequest(deletePtoId));
  };

  const displayDate = (startDate: any, endDate: any) => {
    const newStartDate = moment.utc(startDate);
    const newEndDate = moment.utc(endDate);
    const formattedStartDate = moment(newStartDate).format('MM/DD/YYYY');
    const formattedEndDate = moment(newEndDate).format('MM/DD/YYYY');
    if (formattedStartDate === formattedEndDate) {
      return moment(newStartDate).format('dddd M/D');
    } else {
      return `${moment(newStartDate).format('ddd')}-${moment(newEndDate).format('ddd')} ${moment(
        newStartDate
      ).format('M/D')}-${moment(newEndDate).format('M/D')}`;
    }
  };

  const dummyStyle = {
    borderRadius: '20px',
    marginBottom: '31px',
    height: '213px',
    position: 'relative',
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
  };

  const defautlStyle = {
    height: '100%',
    position: 'relative',
    borderRadius: '12px',
    border: '1px solid #F5F7FF',
    boxShadow: '0px 5px 22px 0px rgba(0, 0, 0, 0.04), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.03)',
  };

  const styleToApply = isLessThan1140 ? dummyStyle : defautlStyle;

  return (
    <>
      <Card
        sx={styleToApply}
        {...other}
      >
        <CardHeader
          sx={{ borderBottom: '1px solid #E5E7EB', height: '64px', paddingTop: '16px !important' }}
          title={
            <Grid
              justifyContent={'space-between'}
              container
              alignItems={'center'}
            >
              <Grid
                sx={{ display: 'flex' }}
                item
              >
                <Typography variant="h6">My requests</Typography>
                <Box
                  sx={{
                    height: '24px',
                    border: '1px solid #6366F1',
                    alignItems: 'center',
                    borderRadius: '12px',
                    marginLeft: '12px !important',
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '13px',
                      fontWeight: '500',
                      color: '#6366F1',
                      paddingLeft: '8px',
                      paddingRight: '8px',
                      paddingTop: '1px',
                    }}
                  >
                    {getAllPtoRequestResponse?.response?.data?.length || 0}{' '}
                    {getAllPtoRequestResponse?.response?.data?.length > 1 ? 'Requests' : 'Request'}
                  </Typography>
                </Box>
              </Grid>
              {isLessThan1140 && (
                <Grid
                  sx={{
                    height: '84px',
                    padding: '24px 24px 24px 24px',
                    background: '#FFF',
                  }}
                  item
                >
                  <Button
                    fullWidth
                    size="small"
                    startIcon={
                      <SvgIcon>
                        <Add />
                      </SvgIcon>
                    }
                    variant="outlined"
                    onClick={handleRequestPTO}
                  >
                    Request a PTO
                  </Button>
                </Grid>
              )}
            </Grid>
          }
        ></CardHeader>
        <Grid style={{ height: '100%', overflowY: 'scroll' }}>
          {getAllPtoError === '' ? (
            <Table
              sx={{
                [`& .${tableCellClasses.root}`]: {
                  borderBottom: 'none',
                },
              }}
            >
              {isLessThan1140 ? (
                <Grid
                  xs={12}
                  container
                >
                  <TableBody sx={{ display: 'flex' }}>
                    {ptoList.map((pto: PtoList) => {
                      const late = 'PTO: ' + pto.hours || '-';
                      const statusColor =
                        String(pto.ptoStatus).toLowerCase() === 'approved'
                          ? 'rgba(21, 183, 158, 0.12)'
                          : String(pto.ptoStatus).toLowerCase() === 'pending'
                          ? 'rgba(247, 144, 9, 0.12)'
                          : 'rgba(240, 68, 56, 0.12)';

                      const labelStatusColor =
                        String(pto.ptoStatus).toLowerCase() === 'approved'
                          ? '#107569'
                          : String(pto.ptoStatus).toLowerCase() === 'pending'
                          ? '#B54708'
                          : '#B42318';

                      return (
                        <TableRow
                          key={pto.uuid}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                            cursor: 'pointer',

                            outline: 'none',
                          }}
                          onMouseEnter={() => setRowId(pto.uuid)}
                          onMouseLeave={() => setRowId('')}
                        >
                          <Box
                            sx={{
                              m: '10px 10px',
                              height: 100,
                              borderRadius: '8px',
                              border: '1px solid  #F5F7FF',
                              background: '#FFF',
                              boxShadow: ' 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
                            }}
                          >
                            <TableCell
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: 10,
                                p: 1,
                              }}
                            >
                              <Box>
                                <Box>
                                  <Typography
                                    variant="subtitle2"
                                    noWrap={true}
                                  >
                                    {displayDate(pto.startDate, pto.endDate)}
                                  </Typography>
                                </Box>
                                {pto?.hours?.length === 0 ? null : (
                                  <Typography
                                    color="text.secondary"
                                    variant="body2"
                                    noWrap={true}
                                  >
                                    {late}
                                  </Typography>
                                )}
                              </Box>
                              <Grid container={rowId === pto.uuid}>
                                <Box
                                  sx={{
                                    background: statusColor,
                                    height: '24px',
                                    borderRadius: '100px',
                                    width: '100px',
                                    transition: 'transform 1s',
                                    transform:
                                      rowId === pto.uuid ? 'translateX(-20px)' : 'translateX(0px)',
                                    marginTop: '12px',
                                  }}
                                >
                                  <Typography
                                    color={labelStatusColor}
                                    textAlign={'center'}
                                    sx={{
                                      fontSize: '12px',
                                      fontWeight: 600,
                                      textTransform: 'uppercase',
                                      letterSpacing: '0.5px',
                                      paddingTop: '3px',
                                    }}
                                    noWrap={true}
                                  >
                                    {pto.ptoStatus}
                                  </Typography>
                                </Box>
                                {rowId === pto.uuid ? (
                                  <Grid
                                    sx={{
                                      marginLeft: '16px',
                                      marginTop: '4px',
                                      transition: 'all 1s ease-in',
                                      opacity: 1,
                                    }}
                                  >
                                    <SvgIcon
                                      fontSize="small"
                                      sx={{
                                        marginLeft: '7px',
                                        marginTop: '12px',
                                      }}
                                      onClick={() => handleDeletePtoRequest(pto.uuid)}
                                    >
                                      <DeleteIconPTO />
                                    </SvgIcon>
                                  </Grid>
                                ) : null}
                              </Grid>
                            </TableCell>
                          </Box>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Grid>
              ) : (
                <TableBody>
                  <Box sx={{ paddingBottom: 25 }}>
                    {ptoList.map((pto: PtoList) => {
                      const late = 'PTO: ' + pto.hours || '-';
                      const statusColor =
                        String(pto.ptoStatus).toLowerCase() === 'approved'
                          ? 'rgba(21, 183, 158, 0.12)'
                          : String(pto.ptoStatus).toLowerCase() === 'pending'
                          ? 'rgba(247, 144, 9, 0.12)'
                          : 'rgba(240, 68, 56, 0.12)';

                      const labelStatusColor =
                        String(pto.ptoStatus).toLowerCase() === 'approved'
                          ? '#107569'
                          : String(pto.ptoStatus).toLowerCase() === 'pending'
                          ? '#B54708'
                          : '#B42318';

                      return (
                        <TableRow
                          key={pto.uuid}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                            cursor: 'pointer',
                            position: 'relative',
                            outline: 'none',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          onMouseEnter={() => setRowId(pto.uuid)}
                          onMouseLeave={() => setRowId('')}
                        >
                          <TableCell sx={{ padding: '12px' }}>
                            <Grid container>
                              <Grid item>
                                <Typography variant="subtitle2">
                                  {displayDate(pto.startDate, pto.endDate)}
                                </Typography>
                                {pto?.hours?.length === 0 ? null : (
                                  <Typography
                                    color="text.secondary"
                                    variant="body2"
                                  >
                                    {late}
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>
                          </TableCell>
                          <TableCell
                            sx={{
                              position: 'absolute',
                              right: 0,
                              borderBottom: 'none',
                              padding: '12px',
                            }}
                          >
                            <Grid container={rowId === pto.uuid}>
                              <Box
                                sx={{
                                  background: statusColor,
                                  height: '24px',
                                  borderRadius: '100px',
                                  width: '100px',
                                  transition: 'transform 1s',
                                  transform:
                                    rowId === pto.uuid ? 'translateX(-20px)' : 'translateX(0px)',
                                }}
                              >
                                <Typography
                                  color={labelStatusColor}
                                  textAlign={'center'}
                                  sx={{
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    paddingTop: '3px',
                                  }}
                                >
                                  {pto.ptoStatus}
                                </Typography>
                              </Box>
                              {rowId === pto.uuid ? (
                                <Grid
                                  sx={{
                                    marginLeft: '16px',
                                    marginTop: '4px',
                                    transition: 'all 1s ease-in',
                                    opacity: 1,
                                  }}
                                >
                                  {/* <SvgIcon
                                  fontSize="small"
                                  onClick={handleRequestPTO}
                                >
                                  <EditIconPTO />
                                </SvgIcon> */}
                                  <SvgIcon
                                    fontSize="small"
                                    sx={{
                                      marginLeft: '7px',
                                      marginTop: '12px',
                                    }}
                                    onClick={() => handleDeletePtoRequest(pto.uuid)}
                                  >
                                    <DeleteIconPTO />
                                  </SvgIcon>
                                </Grid>
                              ) : null}
                            </Grid>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </Box>
                </TableBody>
              )}
            </Table>
          ) : (
            <Typography
              variant="body2"
              mt={4}
              textAlign={'center'}
            >
              {getAllPtoError}
            </Typography>
          )}
        </Grid>
        {!isLessThan1140 && (
          <Grid
            sx={{
              height: '84px',
              padding: '24px 24px 24px 24px',
              position: 'absolute',
              bottom: 0,
              width: '100%',
              background: '#FFF',
            }}
          >
            <Button
              fullWidth
              size="small"
              disabled={!canCreatePto}
              startIcon={
                <SvgIcon>
                  <Add />
                </SvgIcon>
              }
              variant="outlined"
              onClick={handleRequestPTO}
            >
              Request a PTO
            </Button>
          </Grid>
        )}
      </Card>

      <Modal
        open={openPtoModal}
        style={{ position: 'relative' }}
      >
        <RequestPTO
          close={closePTOModal}
          setSucess={openSucessModal}
        />
      </Modal>

      <Modal open={sucessFullRequest}>
        <SucessModal
          close={closeSuccessModal}
          title={successModalTitle.title}
          message={successModalTitle.message}
          isSucess={!errorWhileDelete}
        />
      </Modal>
      <BootstrapDialog
        PaperProps={{ style: { maxWidth: '750px' } }}
        onClose={handleCloseInfo}
        aria-labelledby="customized-dialog-title"
        open={openDeleteModal}
      >
        <ConfirmDeleteModal
          close={handleCloseInfo}
          handleDelete={confirmHandleDeleteModal}
        />
      </BootstrapDialog>
    </>
  );
};
